// // React Dependencies
import React, { useMemo } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { useGLTF } from '@react-three/drei';
import withMallMapModel from './withMallMapModel';

const MapModel = ({ fileName, position }) => {
  const { scene } = useGLTF(`/models/${fileName}`);
  const copiedScene = useMemo(() => scene.clone(), [scene]);

  return (
    <mesh position={position}>
      <primitive object={copiedScene} />
    </mesh>
  );
};

export default withMallMapModel(MapModel);

MapModel.propTypes = {
  fileName: PropTypes.string.isRequired,
  position: PropTypes.arrayOf(PropTypes.number),
};

MapModel.defaultProps = {
  position: [0, 0, 0],
};
